import { Loading as RevelryLoading } from '@revelrygroup/components'

import loadingGif from '../../public/loading.gif'

const Loading: React.FC = () => <RevelryLoading src={loadingGif} />

export default Loading
